// Auto-generated version file for Portal Frontend
// Generated at: 2026-10-21 17:01:02 UTC
// DO NOT EDIT MANUALLY - This file is overwritten on each deployment

// Deployed version (updated by CI/CD)
const deployedVersion = {
  semantic_version: "v0.1.65",
  full_version: "dev-v0.1.65-20261021-1701-d2f7e9ac",
  version_prefix: "0.1",
  version_counter: 65,
  git_sha: "d2f7e9acaaf39d3846b69cfd32ab7b5492b37c20",
  short_sha: "d2f7e9ac",
  timestamp: "20261021-1701",
  environment: "develop",
  deployed_by: "leopthurler",
  deployed_at: "2026-10-21 17:01:02 UTC",
  workflow_run: "39639856226",
  build_date: "2026-10-21T17:01:02+00:00",
  project_name: ""
};

// Local development version (used when running with vite dev server)
const localVersion = {
  semantic_version: "v0.0.0-dev",
  full_version: "local-dev",
  version_prefix: "0.0",
  version_counter: 0,
  git_sha: "local-development",
  short_sha: "local",
  timestamp: "00000000-0000",
  environment: "development",
  deployed_by: "local-developer",
  deployed_at: "Not deployed",
  workflow_run: "N/A",
  build_date: new Date().toISOString(),
  project_name: ""
};

// Auto-detect: use local version in dev mode, deployed version in production build
export const version: {
  semantic_version: string;
  full_version: string;
  version_prefix: string;
  version_counter: number;
  git_sha: string;
  short_sha: string;
  timestamp: string;
  environment: string;
  deployed_by: string;
  deployed_at: string;
  workflow_run: string;
  build_date: string;
  project_name: string;
} = import.meta.env.DEV ? localVersion : deployedVersion;

export type Version = typeof version;
